
/**
 * Logger is an Up specific logger, which has the
 * simply requirement of outputting JSON logs to
 * stdout, Up handles the rest.
 */

export default class Logger {

  /**
   * Construct logger with fields.
   */

  constructor({ fields = {} } = {}) {
    this._fields = fields
  }

  /**
   * Fields returns a new logger inheriting the given fields.
   */

  fields(fields) {
    fields = Object.assign({}, this._fields, fields)
    return new Logger({ fields })
  }

  /**
   * Debug message.
   */

  debug(message, fields) {
    this.write({
      level: 'debug',
      message,
      fields
    })
  }

  /**
   * Info message.
   */

  info(message, fields) {
    this.write({
      level: 'info',
      message,
      fields
    })
  }

  /**
   * Warn message.
   */

  warn(message, fields) {
    this.write({
      level: 'warn',
      message,
      fields
    })
  }

  /**
   * Error message.
   */

  error(message, fields) {
    this.write({
      level: 'error',
      message,
      fields
    })
  }

  /**
   * Fatal message.
   */

  fatal(message, fields) {
    this.write({
      level: 'fatal',
      message,
      fields
    })
  }

  /**
   * Write message.
   */

  write({ level, message, fields }) {
    fields = Object.assign({}, this._fields, fields)
    const scope = fields.scope
    delete fields.scope
    console[level](`%c${scope} —`, 'color: #7048e8; font-weight: 500', message, fields)
  }
}
